/* eslint-disable complexity */
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { regexList } from './regex-list';

export const addressLine1: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value?.value;
  if (
    !value?.match(regexList.addressLineLength) ||
    !value?.match(regexList.addressLine1)
  ) {
    return { error: 'INVALID_ADDR_LINE_1' };
  } else if (!value?.match(regexList.isNaN)) {
    return { error: 'ADDR_WITH_NO_LETTERS' };
  } else {
    return null;
  }
};

export const district: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value?.value;

  if (
    value?.length === 0 ||
    (value?.match(regexList.addressLineLength) &&
      value?.match(regexList.district) &&
      value?.match(regexList.isNaN))
  ) {
    return null;
  } else {
    return { error: 'INVALID_DISTRICT' };
  }
};

export const city: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value?.value;
  if (
    value?.length === 0 ||
    (value?.match(regexList.addressLineLength) &&
      value?.match(regexList.cityAddAddress) &&
      value?.match(regexList.isNaN))
  ) {
    return null;
  } else {
    return { error: 'INVALID_CITY' };
  }
};

export const state: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value;
  if (value === null) {
    return { error: 'SELECT_STATE' };
  }
  return null;
};

export const prefecture: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value;
  if (value === null) {
    return { error: 'SELECT_PREFECTURE' };
  }
  return null;
};

export const zipCode: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value?.value;
  if (value?.length === 0 || value?.match(regexList.zipCode)) {
    return null;
  } else {
    return { error: 'INVALID_ZIP_CODE' };
  }
};

export const ADD_ADDRESS_ERROR_ID = {
  INVALID_ADDR_LINE_1: 'INVALID_ADDR_LINE_1',
  ADDR_WITH_NO_LETTERS: 'ADDR_WITH_NO_LETTERS',
  INVALID_ADDR_LINE_2: 'INVALID_ADDR_LINE_2',
  INVALID_DISTRICT: 'INVALID_DISTRICT',
  INVALID_CITY: 'INVALID_CITY',
  SELECT_STATE: 'SELECT_STATE',
  SELECT_PREFECTURE: 'SELECT_PREFECTURE',
  INVALID_ZIP_CODE: 'INVALID_ZIP_CODE'
};
